export const en = {
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    create: "Create",
    edit: "Edit",
    confirm: "Confirm",
    back: "Back",
    search: "Search...",
    noResults: "No results found.",
    actions: "Actions",
    status: "Status",
    createdAt: "Created",
    copiedToClipboard: "Copied to clipboard",
  },
  nav: {
    dashboard: "Dashboard",
    sites: "Sites",
    settings: "Settings",
    billing: "Billing",
  },
  dashboard: {
    title: "Dashboard",
    totalSites: "Total Sites",
    totalDeploys: "Deploys This Month",
    totalStorage: "Total Storage",
    activeSites: "Active Sites",
    noSites: "No sites yet",
    noSitesDesc: "Create your first site using the Sandbar CLI to get started.",
    cliHint: "Run sandbar init to create a site.",
  },
  onboarding: {
    provisioning: "Setting up your workspace",
    provisioningDesc: "This usually takes just a moment...",
    error: "Something went wrong",
    errorDesc:
      "We couldn\u2019t set up your workspace. Please try refreshing the page or contact support.",
  },
  sites: {
    title: "Sites",
    name: "Name",
    slug: "Slug",
    lastDeploy: "Last Deploy",
    noSites: "No sites yet",
    noSitesDesc: "Create your first site using the Sandbar CLI to get started.",
    openSite: "Open Site",
    viewDeploys: "Deploys",
    viewDomains: "Domains",
    viewTrusts: "Trusts",
    viewSettings: "Settings",
  },
  deploys: {
    title: "Deploys",
    deployId: "Deploy",
    message: "Message",
    fileCount: "Files",
    totalSize: "Size",
    activate: "Activate",
    rollback: "Rollback",
    activateConfirm:
      "This will make this deploy live. All site traffic will be served from this deploy.",
    rollbackConfirm: "This will revert to the previous deploy.",
    noDeploys: "No deploys yet",
    noDeploysDesc: "Push your first deploy using the Sandbar CLI.",
  },
  domains: {
    title: "Domains",
    hostname: "Hostname",
    verification: "Verification",
    ssl: "SSL",
    addDomain: "Add Domain",
    addDomainPlaceholder: "docs.example.com",
    removeDomain: "Remove Domain",
    removeConfirm:
      "This will remove the custom domain and its SSL certificate. Traffic to this hostname will stop working.",
    noDomains: "No custom domains",
    noDomainsDesc: "Add a custom domain to serve your site on your own hostname.",
    dnsInstructions: "DNS Instructions",
  },
  siteSettings: {
    title: "Site Settings",
    general: "General",
    redirects: "Redirects",
    headers: "Headers",
    retention: "Retention",
    dangerZone: "Danger Zone",
    deleteSite: "Delete Site",
    deleteSiteConfirm:
      "Type the site name to confirm deletion. This will permanently delete the site, all deploys, and all custom domains.",
    buildDir: "Build Directory",
    retentionCount: "Deploy Retention Count",
  },
  settings: {
    title: "Settings",
    billing: "Billing",
  },
  billing: {
    title: "Billing",
    currentPlan: "Current Plan",
    managePlan: "Manage Plan",
    siteCount: "Sites",
    contactSales: "Contact Sales",
    recentInvoices: "Recent Invoices",
    noInvoices: "No invoices yet",
  },
  device: {
    title: "Authorize Sandbar CLI",
    description: "A terminal session is requesting access to your workspace.",
    approve: "Authorize",
    approved: "Authorized. You can close this tab and return to your terminal.",
    expired: "This authorization link has expired. Run sandbar login again.",
  },
} as const;
